import "./ContenidoLogin.css";
import React, { useContext, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import {
  faInfoCircle,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { DarkModeContext } from "../../context/DarkModeContext";
import { setToken } from "../../utils/auth";
import {
  ADMIN_ROLE,
  OPERACIONES_ROLE,
  VENDEDOR_HOME_PATH,
  VENDEDOR_ROLE,
} from "../../utils/roleAccess";
import eyeIcon from "./login-nuevo-assets/eye.svg";
import lockIcon from "./login-nuevo-assets/lock.svg";
import userIcon from "./login-nuevo-assets/user.svg";
import backgroundImage from "./login-nuevo-assets/background.png";
import zocoLogo from "./login-nuevo-assets/zoco-logo.png";

const BACKGROUND_VIDEO_URL =
  "https://zoco-ticket-images.s3.us-east-2.amazonaws.com/Videos-landing/hero+pagos.mp4";

const SUPPORT_URL =
  "https://api.whatsapp.com/send/?phone=543813545650&text=Buenos%2Fas+d%C3%ADas%2Ftardes%2Cmi+CUIT+es%3A++tengo+una+consulta+sobre&type=phone_number&app_absent=0";

const ContenidoLogin = ({ setDatosMandados }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Conectar");
  const [contador, setContador] = useState(0);
  const [isUpdateVisible, setIsUpdateVisible] = useState(true);
  const navigate = useNavigate();
  const { darkMode } = useContext(DarkModeContext);
  const apiUrlLogin = process.env.REACT_APP_API_LOGIN;

  useEffect(() => {
    document.body.classList.toggle("login-update-visible", isUpdateVisible);

    return () => {
      document.body.classList.remove("login-update-visible");
    };
  }, [isUpdateVisible]);

  const recargarPagina = () => {
    window.location.reload();
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (!Number.isNaN(Number(value)) && value.length <= 11) {
      setUsuario(value);
    }
  };

  const handleLoginError = () => {
    Swal.fire({
      title: "Revisar Usuario o Contraseña",
      text: "Usuario o Contraseña incorrecta.",
      imageUrl: zocoLogo,
      imageWidth: 100,
      imageHeight: 30,
      imageAlt: "Logo",
      confirmButtonText: "Ok",
      timer: 5000,
      allowOutsideClick: true,
      customClass: {
        container: darkMode ? "swal2-container--dark" : "swal2-container--light",
        confirmButton: "my-swal-button",
      },
    });
    setButtonText("Conectar");
    setIsLoading(false);
    setContador((currentValue) => currentValue + 1);
  };

  const handleLoginSuccess = (data) => {
    setDatosMandados(data);

    if (data.rol === 0) {
      setToken(data.token);
      navigate("/aliados/inicio");
      recargarPagina();
      return;
    }

    if (data.rol === 1) {
      setToken(data.token);
      navigate("/asesores/check");
      recargarPagina();
      return;
    }

    if (data.rol === 2) {
      setToken(data.token);
      navigate("/liquidaciones");
      recargarPagina();
      return;
    }

    if (data.rol === 3) {
      setToken(data.token);
      navigate("/Calidad/Admin");
      recargarPagina();
      return;
    }

    if (data.rol === 4) {
      setToken(data.token);
      navigate("/reclutamiento/busqueda");
      recargarPagina();
      return;
    }

    if (data.rol === 5) {
      setToken(data.token);
      navigate("/facturacion/reporte");
      recargarPagina();
      return;
    }

    if (data.rol === 6) {
      setToken(data.token);
      navigate("/gestor/check");
      recargarPagina();
      return;
    }

    if (data.rol === 7) {
      setToken(data.token);
      navigate("/ZocoConect/Inicio");
      recargarPagina();
      return;
    }

    if (data.rol === ADMIN_ROLE) {
      setToken(data.token);
      navigate("/administracion/crm-seguimiento");
      recargarPagina();
      return;
    }

    if (data.rol === OPERACIONES_ROLE) {
      setToken(data.token);
      navigate("/administracion/importacion-operaciones");
      recargarPagina();
      return;
    }

    if (data.rol === VENDEDOR_ROLE) {
      setToken(data.token);
      navigate(VENDEDOR_HOME_PATH);
      recargarPagina();
      return;
    }

    if (data.rol === 10) {
      setToken(data.token);
      navigate("/diseno/notificaciones");
      recargarPagina();
      return;
    }

    if (data.rol === 11) {
      setToken(data.token);
      navigate("/cajero/inicio");
      recargarPagina();
      return;
    }

    if (data.rol === 12) {
      setToken(data.token);
      navigate("/abmtest/panelinterno");
      recargarPagina();
      return;
    }

    if (data.rol === 13) {
      setToken(data.token);
      navigate("/compliance/panel");
      recargarPagina();
      return;
    }

    if (data.rol === 9) {
      setToken(data.token);
      navigate("/postulante/inicio");
      recargarPagina();
      return;
    }

    if (data.rol === 20) {
      setToken(data.token);
      navigate("/meta/inicio");
      recargarPagina();
      return;
    }

    handleLoginError();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!usuario || !password || contador >= 4) {
      return;
    }

    setIsLoading(true);
    setButtonText("Conectar");

    try {
      const response = await fetch(apiUrlLogin, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Usuario: usuario,
          Password: password,
        }),
      });

      const data = await response.json();
      handleLoginSuccess(data);
    } catch (_) {
      handleLoginError();
    }
  };

  const attemptsMessage = {
    1: "Te quedan 3 intentos más antes de restringir el acceso por motivos de seguridad.",
    2: "Te quedan 2 intentos más antes de restringir el acceso por motivos de seguridad.",
    3: "Te queda 1 intento más antes de restringir el acceso por motivos de seguridad.",
    4: "Llegaste al límite de intentos posible. Te hemos restringido el acceso por motivos de seguridad. Por favor comunicate con el departamento de Liquidaciones para resolver el problema.",
  };

  return (
    <main
      className="login-page theme-minimal"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <video
        className="login-page__background"
        src={BACKGROUND_VIDEO_URL}
        aria-hidden="true"
        preload="auto"
        muted
        autoPlay
        loop
        playsInline
        poster={backgroundImage}
      />

      <header className="login-page__brand">
        <img src={zocoLogo} alt="Zoco" />
      </header>

      <section className="login-page__content" aria-labelledby="login-title">
        <form className="login-form" onSubmit={handleSubmit}>
          <h1 id="login-title">INICIAR SESION</h1>

          <label className="login-field">
            <span className="sr-only">Usuario</span>
            <img className="login-field__icon login-field__icon--user" src={userIcon} alt="" />
            <input
              type="text"
              name="username"
              placeholder="Usuario"
              autoComplete="username"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={11}
              value={usuario}
              onChange={handleInputChange}
              required
            />
          </label>

          <label className="login-field">
            <span className="sr-only">Contraseña</span>
            <img className="login-field__icon login-field__icon--lock" src={lockIcon} alt="" />
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Contraseña"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              maxLength={20}
              required
            />
            <button
              className="login-field__visibility"
              type="button"
              aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              aria-pressed={showPassword}
              onClick={() => setShowPassword((currentValue) => !currentValue)}
            >
              <img src={eyeIcon} alt="" />
            </button>
          </label>

          <button
            className="login-form__submit"
            type="submit"
            disabled={contador >= 4 || isLoading}
          >
            {isLoading ? (
              <>
                Loading...
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              </>
            ) : (
              buttonText
            )}
          </button>

          {attemptsMessage[contador] ? (
            <p className="login-form__error">{attemptsMessage[contador]}</p>
          ) : null}

          <p className="login-form__help">
            ¿Problemas para ingresar?{" "}
            <a href={SUPPORT_URL} target="_blank" rel="noreferrer">
              Tocá aquí.
            </a>
          </p>
        </form>
      </section>

      {isUpdateVisible ? (
        <aside className="login-update" aria-label="Actualización del sistema">
          <button
            type="button"
            className="login-update__close"
            aria-label="Cerrar aviso"
            onClick={() => setIsUpdateVisible(false)}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <strong>Nueva versión 2.0</strong>
          <p>
            Estamos actualizando el sistema.
            <br />
            Próximamente Chat IA y más.
          </p>
        </aside>
      ) : (
        <button
          type="button"
          className="login-update-toggle"
          aria-label="Ver aviso de actualización"
          title="Ver actualización"
          onClick={() => setIsUpdateVisible(true)}
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </button>
      )}
    </main>
  );
};

export default ContenidoLogin;
